/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Created_AtInputs */

const cs_order_created_at = /** @type {(inputs: Order_Created_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vytvoření`)
};

const en_order_created_at = /** @type {(inputs: Order_Created_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created`)
};

/**
* | output |
* | --- |
* | "Created" |
*
* @param {Order_Created_AtInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const order_created_at = /** @type {((inputs?: Order_Created_AtInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Created_AtInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_order_created_at(inputs)
	return cs_order_created_at(inputs)
});